import React from 'react';

const Citation = () => {
  return (
    <div className="max-w-3xlß">
      <p>
        1. Arif & Portlock, et al. (2021). GutMicroNet: an interactive platform for gut microbiome interaction exploration. Biorxiv (Pre-Print) {' '}
        <a
          href="https://www.biorxiv.org/content/10.1101/2021.11.10.468051v2"
          target="_blank"
          rel="noopener noreferrer"
        >
          LINK
        </a>
      </p>
      <br />
      <p>
        2. Shoaie, et al. (2021). Global and temporal state of the human gut microbiome in health and disease. Research Square (Pre-Print) {' '}
        <a
          href="https://www.researchsquare.com/article/rs-339282/v1"
          target="_blank"
          rel="noopener noreferrer"
        >
          LINK
        </a>
      </p>
    </div>
  );
};

export default Citation;
